import { i18n } from "@/i18n";

export default {
  path: "/company",
  name: "CompanyDashboard",
  component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Company/CompanyLayoutView.vue"),
  redirect: { name: "CompanyContractList" },
  meta: {
    breadcrumb: true,
    authRequired: true,
    title: i18n.global.t("myContracts"),
  },
  children: [
    {
      path: "contract",
      name: "CompanyContractList",
      component: () => import(/* webpackChunkName: "dashboard" */ "@/views/Company/CompanyContractListView.vue"),
      meta: {
        title: i18n.global.t("registration.company_dashboard.following_contract.title"),
        breadcrumb: true,
        displayTrainingName: true,
      },
    },
  ],
};
